import request from '@/utils/request'

export function getProductMenu(data) {
  return request({
    url: `/product/getProductMenu`,
    method: 'get',
    params: data
  })
}
